import React from "react";

const Link = (props) => {
  const {
    className,
    hasLink,
    link,
    productId,
    children,
    handleClickItem,
    newWindow = false,
  } = props;
  return hasLink ? (
    <a
      className={className}
      href={link}
      id={productId}
      target={`${newWindow ? "_blank" : "_self"}`}
      rel={`${newWindow ? "noreferrer" : ""}`}
    >
      {children}
    </a>
  ) : (
    <div className={className} id={productId} onClick={() => handleClickItem()}>
      {children}
    </div>
  );
};

export default Link;
